class LocalizationFormUpdated extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );

    const form = this.querySelector("form");
    if (form) {
      form.addEventListener("submit", this.onFormSubmit.bind(this));
    }
  }

  onItemClick(event) {
    console.log(event)
    event.preventDefault();
    const form = this.querySelector("form");
    let input = this.querySelector(
      'input[name="language_code"], input[name="country_code"]'
    );
    if(input) {
      input.value = event.currentTarget.dataset.value;
      console.log(input.value, form);
      if (form) form.submit();
      // refresh the page
      setTimeout(() => {
        console.log(location.href)
        location.reload();
      }, 1000);
    }
  }

  onFormSubmit(event) {
    event.preventDefault();
    // Do what you gotta do. Send an AJAX request or something.
    // The form won't reload the page because you've just prevented its default behavior.
    console.log('hello1')
  }
}
customElements.define("localization-form-updated", LocalizationFormUpdated);
